import { render, staticRenderFns } from "./editcommodity.vue?vue&type=template&id=7d05ff2e&scoped=true&"
import script from "./editcommodity.vue?vue&type=script&lang=js&"
export * from "./editcommodity.vue?vue&type=script&lang=js&"
import style0 from "./editcommodity.vue?vue&type=style&index=0&id=7d05ff2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d05ff2e",
  null
  
)

export default component.exports